import { t } from "../../i18n";
import { setPayoutReminder } from "../../lib/queries";
import { ScheduledEmail } from "./ScheduledEmail";

/**
 * Who hears, on a Thursday morning, that a crew is waiting to be paid.
 *
 * The crews are paid on Thursday afternoon out of the payout run, and the run
 * only holds work somebody ticked. A work order nobody marked complete is not
 * in it, is not late, and shows up nowhere — the crew simply is not paid
 * (ADR 0177). So every Thursday the people who can fix that are emailed every
 * open job, with the ones waiting on a tick marked.
 */
export function ThursdayReminder() {
  return (
    <ScheduledEmail
      title={t("Thursday payout reminder")}
      blurb={
        <>
          {t(
            "Every Thursday at 7am, everyone below is emailed every open job, with the ones whose crew work has not been marked complete or approved flagged. Nobody chosen means it is not sent.",
          )}
        </>
      }
      functionName="thursday-reminder"
      sendLabel={t("Send this week’s now")}
      read={(settings) => ({
        from: settings?.payout_reminder_from_profile_id ?? null,
        to: settings?.payout_reminder_profile_ids ?? [],
      })}
      save={setPayoutReminder}
      sentNote={(result) =>
        typeof result.flagged === "number"
          ? t("Sent to {n} people, {flagged} jobs marked.", {
              n: result.sent?.length ?? 0,
              flagged: result.flagged,
            })
          : t("Sent to {n} people.", { n: result.sent?.length ?? 0 })
      }
    />
  );
}
